module.exports = __webpack_public_path__ + "img/o3.35ebc71e.png";